export default __webpack_public_path__ + "static/media/IMG-20230124-WA0011.7dc526b5.jpg";